import { SortOrder } from 'antd/lib/table/interface';

import { SortingEnum } from 'api/backofficeApiClient';

export const getSortOrderRequestValue = (sortOrder?: SortOrder) => {
  switch (sortOrder) {
    case 'ascend':
      return SortingEnum.Asc;

    case 'descend':
      return SortingEnum.Desc;

    default:
      return undefined;
  }
};
